import passwordSagas from './password/sagas';

const sagas = [...passwordSagas];

export default sagas;
